import { extrairCorpoReceita } from './extrairCorpoReceita';

export const TIPO_RECEITA_LIVRE = 'Livre';
export const ROTULO_RECEITA_LIVRE = 'Receita Livre (Impressa)';

/** Tira o cabeçalho automático (data, nome, endereço e tipo de uso) ao virar receita livre. */
export function textoParaReceitaLivre(texto = '') {
  const original = String(texto ?? '');
  const semUso = extrairCorpoReceita(original);
  const base = semUso !== original ? semUso : original;

  return base
    .replace(/^[ \t]*Marília\/SP,[^\n]*(?:\r?\n)+/i, '')
    .replace(/^[ \t]*Nome:[^\n]*(?:\r?\n)?/i, '')
    .replace(/^[ \t]*Endere[cç]o:[^\n]*(?:\r?\n)*/i, '')
    .replace(/^(?:[ \t]*\r?\n)+/, '');
}

export function ehReceitaLivre(receitaOuTipo) {
  const tipo =
    typeof receitaOuTipo === 'string'
      ? receitaOuTipo
      : receitaOuTipo?.TIPORECEITA || receitaOuTipo?.tipo;

  return (
    String(tipo || '')
      .trim()
      .toLowerCase() === 'livre'
  );
}
